import './PdfViewer.css'

import React, {useEffect, useState} from "react";
import { useParams } from "react-router-dom";
import SinglePagePDFViewer from "./pdf/single-page";

import ViewerService from "../../services/itSoftViewer.service";

const DossierMetier = () => {
    const { numSecu } = useParams();
    const { exercice } = useParams();
    const [load, setLoad] = useState(true);
    const [url, setUrl] = useState('');


    useEffect(() => {
        initViewer();
    }, []);

    const initViewer = () => {
        let token = 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJORUEiLCJyb2xlcyI6IlBVVCxHRVQiLCJpYXQiOjE3MjY4NDY0MjcsImV4cCI6MjA1Mzg5NzIwMH0.sykHGtHZQAQWdcSZ0KD0mA1XH0lFsr7fay8R81-kDPP5TwbGN65bN92augmtaliFnuoZDtNXLkHNzg_68UVQgw';
        ViewerService.getItSoftFileByNumSecuAndExercice(numSecu, exercice).then(
           (response) => {
                ViewerService.getItSoftFile(response, token).then(
                    (res) => {
                        const blob = new Blob([res.data], { type: 'application/pdf' });
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            setUrl(window.URL.createObjectURL(blob));
                            window.navigator.msSaveOrOpenBlob(blob, res.filename);
                            setLoad(false);
                        } else {
                            const link = document.createElement('a');
                            link.href = window.URL.createObjectURL(blob);
                            link.setAttribute('download',res.filename);
                            document.body.appendChild(link);
                            link.click();
                            window.location.href = window.URL.createObjectURL(blob);
                            document.body.removeChild(link);   
                        }
                    },
                    (error) => {
                        if (error.response.data.code == 'ERR_02') { 
                            window.location.href = '/error/404';
                        } else {
                            window.location.href = '/error/500';
                        }
                    }
                );
           },
           (error) => {
                if (error.response.data.code == 'ERR_02') { 
                    window.location.href = '/error/404';
                } else {
                    window.location.href = '/error/500';
                }
           }
       );

    };

    const isLoading = () => {
        if(load) {
            return (
                <div className="pdf-load">
                    <div className="spinner">
                        <div className="load-msg">
                            <h2>Veuillez patienter pendant le chargement du document...</h2>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="pdf-container">
                    <SinglePagePDFViewer pdf={url} />
                </div>
            )
        }
    }

    return (
        <div className="pdf-viewer">
            { isLoading() }
        </div>
    );
};

export default DossierMetier;
